import { toast } from "sonner";
import React, { useState } from "react";
import Button from "../../../utils/Button";
import { api } from "../../lib/api";
import { useUser } from "../../components/auth-provider";

const ContactUs: React.FC = () => {
	const [title, setTitle] = useState<string>("");
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [description, setDescription] = useState<string>("");
	const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

	const { user } = useUser();

	const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.preventDefault();
		setIsLoading(true);
		try {
			if (!title.trim() && !description.trim()) {
				toast.error("Please fill all the fields");
				return;
			}

			const data: any = await api.post("api/v1/auth/contact", {
				fullname: user.name,
				message: description,
				useremail: user.email,
			});

			if (data.success) {
				setTitle("");
				setDescription("");
				setIsSubmitted(true);
				toast.success("Message sent successfully");
			}
		} catch (error) {
			console.error("Error : ", error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div style={{ display: "flex", flexDirection: "column", height: "100vh", fontFamily: "Inter", padding: "0.5rem" }}>
			<div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "1rem", height: "100%" }}>
				<h3
					style={{
						margin: 0,
						color: "#13123e",
						lineHeight: "1.4",
						textAlign: "left",
						fontWeight: "600",
						fontSize: "1.25rem",
					}}
				>
					Contact Us
				</h3>

				<form style={{ flex: 1 }}>
					<label
						htmlFor="title"
						style={{
							color: "#08081A",
							display: "block",
							fontWeight: "500",
							fontSize: "0.875rem",
							marginBottom: "0.375rem",
						}}
					>
						Title
					</label>
					<input
						required
						id="title"
						type="text"
						name="title"
						value={title}
						placeholder="Enter a title"
						style={{
							width: "100%",
							padding: "0.5rem",
							marginBottom: "0.5rem",
							fontSize: "12px",
							borderRadius: "0.375rem",
							border: "1px solid #e7e7ec",
							color: "#61607E",
						}}
						onChange={(e) => setTitle(e.target.value)}
					/>
					{/* Description */}
					<label
						htmlFor="description"
						style={{
							display: "block",
							fontSize: "0.875rem",
							fontWeight: "500",
							marginBottom: "0.375rem",
							color: "#08081A",
						}}
					>
						Description
					</label>
					<textarea
						required
						id="description"
						name="description"
						value={description}
						placeholder="Enter a Description"
						style={{
							width: "100%",
							height: "5.625rem",
							padding: "0.5rem",
							marginBottom: "0.5rem",
							fontSize: "12px",
							borderRadius: "0.375rem",
							border: "1px solid #e7e7ec",
							color: "#61607E",
						}}
						onChange={(e) => setDescription(e.target.value)}
					/>
				</form>

				<div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
					<Button onClick={(e) => handleSubmit(e)} loading={isLoading}>
						Send
					</Button>
				</div>
			</div>
		</div>
	);
};

export default ContactUs;
